import isBrowser from '../../../utils/isBrowser'

export function isInNewCartExperiment() {
  if (!isBrowser()) {
    return false
  }

  return true
}
